import type { Location } from "../data/types.js";

const SITE_URL = "https://map.kimonorentalann.com";

export type ShareResult = "shared" | "copied" | "cancelled" | "error";

export async function shareLocation(loc: Location): Promise<ShareResult> {
  const url = `${SITE_URL}?spot=${loc.id}`;
  const text = `${loc.name} — kimono photo spot near Senso-ji`;

  if (typeof navigator !== "undefined" && navigator.share) {
    try {
      await navigator.share({ title: loc.name, text, url });
      return "shared";
    } catch {
      return "cancelled";
    }
  }

  try {
    await navigator.clipboard.writeText(url);
    return "copied";
  } catch {
    return "error";
  }
}
